import 'regenerator-runtime/runtime';
import { ApexNumericComponent } from '@fmr-pr103625/apex-numeric';
import { apexCustomElement } from '@fmr-pr103625/apex-core';
import { ApexSlotableMixin } from '@fmr-pr103625/apex-slots';
import { ApexValidationRuleTypes } from '@fmr-pr103625/apex-validations';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const i=(i,e)=>"method"===e.kind&&e.descriptor&&!("value"in e.descriptor)?{...e,finisher(n){n.createProperty(e.key,i);}}:{kind:"field",key:Symbol(),placement:"own",descriptor:{},originalKey:e.key,initializer(){"function"==typeof e.initializer&&(this[e.key]=e.initializer.call(this));},finisher(n){n.createProperty(e.key,i);}};function e(e){return (n,t)=>void 0!==t?((i,e,n)=>{e.constructor.createProperty(n,i);})(e,n,t):i(e,n)}

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var n;null!=(null===(n=window.HTMLSlotElement)||void 0===n?void 0:n.prototype.assignedElements)?(o,n)=>o.assignedElements(n):(o,n)=>o.assignedNodes(n).filter((o=>o.nodeType===Node.ELEMENT_NODE));

var version = "3.5.3";

class ApexCurrencyComponent extends ApexNumericComponent {
    constructor() {
        super(...arguments);
        //#region PROPERTIES
        this.label = 'Currency';
        this.decimalPlaces = 2;
        // setting this as a default
        this.leadingIcon = '$';
        //#endregion
    }
    get min() {
        return this._min;
    }
    set min(newValue) {
        this._min = newValue;
        this._validationRules.validations.numericMin = this.min;
        this._validationText.validations.numericMin =
            this._validationText.validations.numericMin || `Value entered must be greater than or equal to $${this.min}`;
        this.updateValidationRule(ApexValidationRuleTypes.NUMERIC_MIN);
    }
    get max() {
        return this._max;
    }
    set max(newValue) {
        this._max = newValue;
        this._validationRules.validations.numericMax = this.max;
        this._validationText.validations.numericMax =
            this._validationText.validations.numericMax || `Value entered must be less than or equal to $${this.max}`;
        this.updateValidationRule(ApexValidationRuleTypes.NUMERIC_MAX);
    }
    //#endregion
    //#region LIFE CYCLE HOOKS
    firstUpdated() {
        super.firstUpdated();
        this.classList.add('apex3-currency');
    }
}
ApexCurrencyComponent.version = version;
__decorate([
    e({ type: String, attribute: 'label' }),
    __metadata("design:type", Object)
], ApexCurrencyComponent.prototype, "label", void 0);
__decorate([
    e({ type: Number, attribute: 'decimal-places' }),
    __metadata("design:type", Object)
], ApexCurrencyComponent.prototype, "decimalPlaces", void 0);
__decorate([
    e({ type: Number, attribute: 'min' }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ApexCurrencyComponent.prototype, "min", null);
__decorate([
    e({ type: Number, attribute: 'max' }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ApexCurrencyComponent.prototype, "max", null);
const ApexCustomElementMixin = apexCustomElement({
    namespace: 'apex',
    shadowDOM: false,
    name: 'currency',
    pvdNamespace: 'pvd'
});
// @ts-expect-error
class ApexCurrency extends ApexSlotableMixin(ApexCustomElementMixin(ApexCurrencyComponent)) {
}

export { ApexCurrency, ApexCurrencyComponent };
//# sourceMappingURL=component.js.map
